export const ROW_LAYOUT = ['grid-1', 'grid-1', 'grid-2', 'grid-2', 'grid-2', 'grid-2', 'grid-1', '40px'];
export const COLUMNS = [
  { name: 'Move' },
  { name: 'Rank' },
  { name: 'Task/Group Name' },
  { name: 'Specify Body Location?' },
  { name: 'Measure Unit' },
  { name: 'Description' },
  { name: 'Modifications' },
  { name: 'Edit' },
];
